// extracted by mini-css-extract-plugin
module.exports = {"wrapped":"Wrapped_wrapped__mzbCW"};